import { Route } from 'vue-router'

export function afterEach (to: Route, from: Route) {
  // NetSuite data is loaded on demand from components / user session hooks
}
